import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Image from 'components/Common/Image'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

export interface HighlightCardData {
  id: string
  imageId: string
  title: string
  body: string
  presentedBy?: string
  presentedByLogoId?: string
  presentedByLogoHeight?: number
}

const CardImageWrapper = styled.div`
  width: ${rem(110)};
  min-width: ${rem(110)};
  height: ${rem(99)};
  border-radius: ${rem(4)};
  overflow: hidden;

  ${mediaQueryUp.desktop} {
    width: 100%;
    min-width: unset;
    height: ${rem(331)};
    border-radius: ${rem(8)};
  }
`

const CardContent = styled(Group)`
  flex: 1 1 0;
  min-width: 0;
`

interface Props {
  data: HighlightCardData
}

function LeLiveHighlightCard({ data }: Props) {
  const intl = useIntl()

  return (
    <Group direction="horizontal" desktopDirection="vertical" gap={16} desktopGap={8}>
      <CardImageWrapper>
        <Image
          id={data.imageId}
          alt={data.title}
          width={267}
          height={331}
          dpr={2}
          enhancedFormats
          fit="center"
          objectFit="cover"
        />
      </CardImageWrapper>
      <CardContent direction="vertical" gap={2}>
        <Heading variant="heading5" as="h3">
          {data.title}
        </Heading>
        <BodyText variant="large" colour="light-foreground-alt">
          {data.body}
        </BodyText>
        {data.presentedBy && (
          <Group direction="horizontal" gap={8} verticalAlign="center">
            <BodyText variant="small" colour="light-foreground-alt">
              {intl.formatMessage({
                id: 'EUhsPfGFffG82g8wsQu-',
                defaultMessage: 'Presented by',
                description: 'Attribution label shown before a sponsor logo on a highlight card in the LE Live event page',
              })}
            </BodyText>
            {data.presentedByLogoId && (
              <Image
                id={data.presentedByLogoId}
                alt={data.presentedBy}
                height={data.presentedByLogoHeight ?? 40}
                dpr={2}
                enhancedFormats={false}
              />
            )}
          </Group>
        )}
      </CardContent>
    </Group>
  )
}

export default LeLiveHighlightCard
